import React, { type ReactNode, useCallback, memo, useRef } from 'react';
import { styled } from '@compiled/react';
import noop from 'lodash/noop';
import Button from '@atlaskit/button';
import EditorFeedbackIcon from '@atlaskit/icon/glyph/editor/feedback';
import { useFeedbackCollector } from '@atlassian/jira-business-feedback-collector';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { QuickstartNudge } from '@atlassian/jira-navigation-apps-sidebar-common';
import { FeedbackNudgeAsync } from '@atlassian/jira-software-onboarding-nudges--next/src/async';
import messages from './messages';

const FEEDBACK_GROUP_ID = 'jbus-feedback';

const FeedbackButton = () => {
	const { formatMessage } = useIntl();
	const openFeedbackModal = useFeedbackCollector();
	const buttonRef = useRef<HTMLButtonElement>(null);
	const renderNudgeWrapper = useCallback(
		(children: ReactNode) => <FeedbackNudgeAsync>{children}</FeedbackNudgeAsync>,
		[],
	);

	const onClickOld = useCallback(() => {
		openFeedbackModal(FEEDBACK_GROUP_ID);
	}, [openFeedbackModal]);

	const onClick = useCallback(() => {
		openFeedbackModal(FEEDBACK_GROUP_ID, noop, buttonRef);
	}, [openFeedbackModal]);

	return (
		<QuickstartNudge renderWrapper={renderNudgeWrapper}>
			<Button
				ref={buttonRef}
				iconBefore={<EditorFeedbackIcon label="" size="small" />}
				appearance="subtle-link"
				onClick={fg('jwm_feedback_return_focus_to_button') ? onClick : onClickOld}
			>
				<Content>{formatMessage(messages.feedback)}</Content>
			</Button>
		</QuickstartNudge>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Content = styled.span({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: '12px',
});

export default memo(FeedbackButton);
